var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"thumbnail",class:{ 'clickable' : _vm.hasSrc }},[(!_vm.hasSrc)?_c('span',{staticClass:"empty"},[_c('i',{staticClass:"fas fa-file-audio fa-3x"})]):_vm._e(),_vm._v(" "),(_vm.hasSrc)?_c('span',{staticClass:"empty"},[_c('i',{staticClass:"fas fa-play fa-3x",staticStyle:{"color":"#848484"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae1001b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/audio-preview.vue
// module id = null
// module chunks = 